module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-management"
  }, [_c('div', {
    staticClass: "with-actions"
  }, [_c('h1', [_vm._v("用户管理")]), _c('div', {
    staticClass: "ui buttons actions"
  }, [_c('div', {
    staticClass: "ui basic button",
    on: {
      "click": function($event) {
        _vm.create_user()
      }
    }
  }, [_c('i', {
    staticClass: "add icon themed text inline"
  }), _c('span', {
    staticClass: "themed text"
  }, [_vm._v("添加用户")])])])]), _c('auto-table', {
    attrs: {
      "defines": _vm.$defines.user,
      "data": _vm.formartted_users,
      "actions": "edit",
      "unstackable": "unstackable"
    },
    on: {
      "action:edit": _vm.edit_user
    }
  }), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog_visible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog_visible = $event
      }
    }
  }, [_c('form-user', {
    attrs: {
      "user": _vm.dialog_user
    },
    on: {
      "exit": _vm.edit_exit
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-120bd0dd","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/pages/Admin/UserManagement.vue
// module id = 457
// module chunks = 0